import React from 'react'

const component = 'tag-filter'

export function TagFilter({ doc_count, label, onClickCallback, isActive }) {
    const activeClass = isActive ? `${component}__filter--active` : ''
    return (
        <div onClick={onClickCallback} className={`${component}__filter ${activeClass}`}>
            <span className={`${component}__label`}>{label}</span>
            {doc_count ? <span className={`${component}__count`}>&nbsp;({doc_count})</span> : null}
        </div>
    )
}
